import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PreviewPrint } from '@app/src/common/PreviewPrint';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import {
  Price,
  Item,
  Description,
  List,
  Title,
  IconInfo,
  ModalContent
} from './styled';
import { Checkbox } from '@app/src/common/Checkbox';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { Icon } from '@app/src/common/Icon';
import {
  VignetteOptionModal,
  selectExtracharge,
  fetchVignette,
  setVignetteValue,
  clearVignetteValue
} from '@app/src/views/StepTwo/channelPublication';
import { Modal } from '@app/src/common/Modal';

interface Props {
  categoryTheme?: CategoryModel;
  printData: TypePublicationModel;
  isShowPhotoUploader?: boolean;
  getPrice?: Function;
}

export const SectionExtracharges: React.FC<Props> = ({
  categoryTheme,
  printData,
  isShowPhotoUploader,
  getPrice
}) => {
  const dispatch = useDispatch();
  const { id } = printData;
  const [ isOpenModalVignette, setIsOpenModalVignette ] = useState(false);
  const [ settings, setSettings ] = useState({
    bold: false,
    titleCenter: false,
    highlight: false,
    starCount: null,
    header: '',
    vignette: false,
    vignetteValue: ''
  });
  const currentExtracharge = useSelector(state => state.extracharge.data[id].data);
  const currentVignette = useSelector(state => state.extracharge.data[id].vignette);
  const { title, description, category } = useSelector(state => state.print.general);
  const printExtracharges = useSelector(state => state.print.extracharges);
  const [ isShowModal, setIsShowModal ] = useState(false);
  const vignettes = useSelector(state => state.vignette.data);
  const printPhotoVignette = useSelector(state => state.photoVignette.data);
  const [fromInput, setFromInput] = useState(false);

  useEffect(() => {
    if (settings && settings.vignette && vignettes && vignettes.length === 0) {
      dispatch(fetchVignette(category, id));
    }
  }, [settings.vignette, vignettes]);

  useEffect(() => {
    if (printExtracharges &&  printExtracharges[id] && printExtracharges[id].vignette) {
      dispatch(setVignetteValue(id, printExtracharges[id].vignette));
    }
    if (currentExtracharge && currentExtracharge.length > 0) {
      let obj = {};
      let priceIgv = 0;
      let price = 0;
      currentExtracharge.map((item) => {
        if (item.checked === true) {
          obj[item.style] = item.styleValue;
          priceIgv = priceIgv + item.priceIgv;
          price = price + item.price;
          if (item.style === 'vignette') {
            if (currentVignette) {
              dispatch(setVignetteValue(id, currentVignette));
              obj['vignetteValue'] = currentVignette.name;
            }
          }
        } else {
          if (item.style === 'vignette') {
            dispatch(clearVignetteValue(id));
          }
        }
      });
      getPrice && getPrice({
        price,
        priceIgv
      });
      setSettings({
        ...settings,
        ...obj
      });
    }
  }, [currentExtracharge, currentVignette, printExtracharges]);

  const formatPrice = (price: number) => price.toFixed(2);

  const handleChangeCheckbox = (_isChecked, index, item) => {
    if (!item.checked) {
      setSettings({
        ...settings,
        [item.style] : item.styleValue
      });
      if (item.input === 'vignette') {
        setIsOpenModalVignette(true);
        setFromInput(true);
      }
    } else {
      setSettings({
        ...settings,
        [item.style] : null
      });
    }
    dispatch(selectExtracharge(id, index, !item.checked));
  };

  const handleClickCloseModal = useCallback((item) => {
    if (settings && !settings.vignetteValue && !item) {
      const indexVignette = currentExtracharge.findIndex(item => item.input === 'vignette' )
      dispatch(selectExtracharge(id, indexVignette, false));
      setSettings({
        ...settings,
        vignetteValue: null
      });
    }
    setIsOpenModalVignette(false);
  }, [dispatch]);

  const handleChangeVignette = useCallback((item) => {
    dispatch(setVignetteValue(id, item));
    setSettings({
      ...settings,
      vignetteValue : item.name
    });
    setIsOpenModalVignette(false);
  }, [settings]);

  const handleClickEditVignette = () => {
    setFromInput(false)
    setIsOpenModalVignette(true);
  };

  const handleCloseModal = () => {
    setIsShowModal(false)
  };

  const handleClickIconInfo = () => {
    setIsShowModal(true);
  };

  const getDisplayExtracharges = (item) => (item.alias !== 'fotovineta' && item.alias !== 'palabra-extra') ? true : false;

  return(
    <React.Fragment>
      <Title><span>Vista referencial</span> <IconInfo onClick={handleClickIconInfo}><Icon data-name="icon-info" width="14" height="14" fill={categoryTheme.color} /></IconInfo></Title>
      <Modal show={isShowModal} closeModal={handleCloseModal}>
        <ModalContent>
          Algunos destaques no se pueden combinar. Por ejemplo: Estrellas con viñetas o con los Encabezados.
        </ModalContent>
      </Modal>
      <VignetteOptionModal
        modalTitle="Seleccione viñeta"
        show={isOpenModalVignette}
        handleClickCloseModal={handleClickCloseModal}
        colorTheme={categoryTheme.color}
        handleChangeRadioInput={handleChangeVignette}
        initialValue={settings && settings.vignetteValue}
        origin={fromInput}
      />
      <PreviewPrint
        channelId={id}
        title={title}
        words={description}
        colorTheme={categoryTheme.color}
        isShowPhotoUploader={isShowPhotoUploader}
        handleClickEditVignette={handleClickEditVignette}
        isEditable
        imageDefault={printPhotoVignette && printPhotoVignette[id] && printPhotoVignette[id].data}
        {...settings}
      />
      <List>
        {
          currentExtracharge && currentExtracharge.length > 0 &&
            currentExtracharge.map((item, index) => (
                <Item key={index} isDisplay={getDisplayExtracharges(item)}>
                  <Checkbox
                    handleChange={(isChecked) => handleChangeCheckbox( isChecked, index, item)}
                    name={item && item.input}
                    value={item && item.value}
                    colorActive={categoryTheme.color}
                    disabled={item && item.disabled}
                    checked={item && item.checked}
                  ><Description>{item && item.name} <Price>S/ {formatPrice(item && item.price)}</Price></Description></Checkbox>
                </Item>
              ))
        }
      </List>
    </React.Fragment>
)};
